import { useState } from "react";
import {
  ClockIcon,
  MapPinIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";

const scheduleData = {
  Today: [
    {
      title: "Group Meeting",
      time: "in 32 minutes",
      location: "Conference room 1B",
    },
    { title: "Coffee Break", time: "10:30 AM" },
    { title: "Public Beta Release", time: "11:00 AM" },
    { title: "Lunch", time: "12:10 PM" },
    { title: "Dinner with David", time: "05:30 PM", location: "Magnolia" },
    { title: "Jane's Birthday Party", time: "07:30 PM", location: "Home" },
    {
      title: "Overseer's Retirement Party",
      time: "09:30 PM",
      location: "Overseer's room",
    },
  ],
  Tomorrow: [
    {
      title: "Marketing Meeting",
      time: "09:00 AM",
      location: "Conference room 1A",
    },
    { title: "Public Announcement", time: "11:00 AM" },
    { title: "Lunch", time: "12:10 PM" },
    {
      title: "Meeting with Beta Testers",
      time: "03:00 PM",
      location: "Conference room 2C",
    },
    { title: "Live Stream", time: "05:30 PM" },
    { title: "Release Party", time: "07:30 PM", location: "CEO's house" },
    {
      title: "CEO's Private Party",
      time: "09:30 PM",
      location: "CEO's Penthouse",
    },
  ],
};

const ScheduleWidget = () => {
  const [activeTab, setActiveTab] = useState("Today");

  const handleTabChange = (tab: "Today" | "Tomorrow") => {
    setActiveTab(tab);
  };

  return (
    <div className="bg-dry border border-border text-gray-200 rounded-xl shadow p-6 w-full">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Schedule</h2>
        <div className="flex gap-2">
          {["Today", "Tomorrow"].map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabChange(tab)}
              className={`px-4 py-1 rounded-full text-sm font-medium ${
                activeTab === tab
                  ? "bg-white text-gray-900"
                  : "bg-gray-700 text-gray-200"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* List */}
      <ul className="divide-y divide-gray-700">
        {scheduleData[activeTab].map((item, index) => (
          <li key={index} className="py-4 flex items-start justify-between">
            <div>
              <h3 className="text-sm font-medium text-white">{item.title}</h3>
              <div className="mt-1 flex flex-col sm:flex-row sm:items-center text-sm text-gray-400 gap-2 sm:gap-4">
                {item.time && (
                  <span className="flex items-center gap-1">
                    <ClockIcon className="w-4 h-4 text-gray-500" />
                    {item.time}
                  </span>
                )}
                {item.location && (
                  <span className="flex items-center gap-1">
                    <MapPinIcon className="w-4 h-4 text-gray-500" />
                    {item.location}
                  </span>
                )}
              </div>
            </div>
            <ChevronRightIcon className="w-5 h-5 text-gray-500 mt-1 sm:mt-0" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduleWidget;
